// adminUpload.js
import API from "../../config/api";

const adminUploadData = async (event) => {
  event.preventDefault();

  let file = event.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  try {
    let results = await API.adminUpload(formData, () => {});
    return results;  // <-- IMPORTANT
  } catch (error) {
    console.log(error);
    return null;     // <-- avoid undefined
  }
};

export default adminUploadData;
